<div class="container p-0">
  <form [formGroup]="profileForm" (ngSubmit)="upsertEmployeeProfile(inProgress)">
    <div class="main-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-column align-items-center text-center">
                <div class="avatar-container">
                  <img 
                    [src]="image ? image : 'assets/images/avatar.png'" 
                    alt="avatar" 
                    class="avatar-img">
                </div>                
                <div class="mt-3">
                  <h4 class="capitailized">{{employee.employeeData.name}}</h4>
                  <p class="text-secondary mb-1">
                    {{employee.employeeData.dob | date:'MMM dd, yyyy'}}</p>
                  <p class="text-mute font-size-sm">{{employee.employeeData.email}}</p>
                </div>
              </div>
            <hr class="my-4"/> 
						<ul class="list-group list-group-flush">
							<li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let profile of profile?.medium">
								<h6 class="mb-0"><i [ngClass]="[profile?.social?.icon]" [style.fontSize.px]="22" style="margin-bottom: 15px;"></i> {{profile.social.name}}</h6>
                <a [href]="profile.link" target="_blank" class="text-primary truncated-link" style="text-decoration: underline;">{{profile.link}}</a>
							</li>
						</ul>
            </div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <div class="row g-3" formGroupName="employeeData">
                <div class="col-md-4">
                  <label for="name" class="form-label">Name</label>
                  <div class="input-group">
                    <select class="form-select emp-selection" formControlName="title" disabled
                      [ngClass]="{'is-invalid': submitted && u.controls.title.errors}">
                      <option *ngFor="let surname of surnames" [ngValue]="surname">{{surname}}</option>
                    </select>
                    <input type="text" class="form-control ps-1" id="name" placeholder="Enter Name" readOnly
                      [ngClass]="{'is-invalid': submitted && u.controls.name.errors}" formControlName="name"
                      ngbAutofocus autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.name.errors">
                      <span *ngIf="u.controls.name.errors?.required">Please provide a valid name.</span>
                      <span *ngIf="u.controls.name.errors?.pattern">Please provide a valid name.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="surname" class="form-label">Surname</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                      <i class='bx bx-user-plus'></i>
                    </span>
                    <input type="text" class="form-control ps-1" id="surname" placeholder="Enter Surname" readOnly
                      [ngClass]="{'is-invalid': submitted && u.controls.surname.errors}" formControlName="surname"
                      autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.surname.errors">
                      <span *ngIf="u.controls.surname.errors.required">Please provide a valid surname.</span>
                      <span *ngIf="u.controls.surname.errors.pattern">Please provide a valid surname.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="gender" class="form-label">Gender</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-body'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="gender" [readonly]="u.controls.id.value"
                      placeholder="Select a Gender" [ngClass]="{'is-invalid': submitted && u.controls.gender.errors}"
                      [clearable]="false">
                      <ng-option *ngFor=" let gender of genders;" [value]="gender">{{gender}}</ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="code" class="form-label">Code</label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0">
                      <i class='bx bx-code-block'></i></span>
                    <input type="text" class="form-control ps-1" id="code" placeholder="Code" readOnly
                      [ngClass]="{'is-invalid': submitted && e.code?.errors}" formControlName="code"
                      autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && e.code?.errors">
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="dob" class="form-label">Date Of Birth</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                      <i class='bx bx-calendar'></i>
                    </span>
                    <input type="date" class="form-control ps-1" id="dob" formControlName="dob" readonly
                      [ngClass]="{'is-invalid': submitted && u.controls.dob.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.dob.errors">
                      <span *ngIf="u.controls.dob.errors.required">Please provide a valid date of birth.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="doj" class="form-label">Date Of Joining</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                      <i class='bx bx-calendar'></i>
                    </span>
                    <input type="date" class="form-control ps-1" id="doj" formControlName="doj" readonly
                      [ngClass]="{'is-invalid': submitted && u.controls.doj.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.doj.errors">
                      <span *ngIf="u.controls.doj.errors.required">Please provide a valid date of joining.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="report" class="form-label">Reported To</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="reportTo"
                      [readonly]="u.controls.id.value" placeholder="Select a Reported To" [clearable]="false"
                      [searchable]="false" [multiple]="false"
                      [ngClass]="{'is-invalid': submitted && u.controls.id?.errors}">
                      <ng-option *ngFor="let reportTo of reports" [value]="reportTo?.employeeData?.id">
                        {{ reportTo?.employeeData?.name }}
                      </ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.id.errors">
                      <span *ngIf="u.controls.id.errors.required">Please select a Reported To</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="report" class="form-label">Address To</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="addressTo"
                      [readonly]="u.controls.id.value" placeholder="Select a Addresse To"
                      [ngClass]="{'is-invalid': submitted && u.controls.id?.errors}">
                      <ng-option *ngFor="let addressTo of reports" [value]="addressTo?.employeeData?.id">
                        {{ addressTo?.employeeData?.name }}
                      </ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.id.errors">
                      <span *ngIf="u.controls.id.errors.required">Please select a Addresse To</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="blood" class="form-label">Blood Group</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bxs-donate-blood'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="blood"
                      [readonly]="u.controls.id.value" placeholder="Select Blood Group"
                      [ngClass]="{'is-invalid': submitted && u.controls.blood?.errors}" [clearable]="false">
                      <ng-option *ngFor="let blood of bloods;" [value]="blood">{{blood}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.blood.errors">
                      <span *ngIf="u.controls.blood.errors.required">Please select a blood group.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="email" class="form-label">Email</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-envelope'></i></span>
                    <input type="text" class="form-control ps-1" id="email" placeholder="Enter your email" readonly
                      [ngClass]="{'is-invalid': submitted && u.controls.email?.errors}" formControlName="email"
                      autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.email.errors">
                      <span *ngIf="u.controls.email.errors.required">Please provide an email.</span>
                      <span *ngIf="u.controls.email.errors.pattern">Please provide a valid email address.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="aadhaar" class="form-label">Aadhar Number</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-barcode-reader'></i></span>
                    <input type="text" class="form-control ps-1" id="aadhaar" placeholder="Enter Aadhar No" readonly
                      [ngClass]="{'is-invalid': submitted && u.controls.aadhaar?.errors}" formControlName="aadhaar"
                      autocomplete="off" [attr.value]="profileForm.value.aadhaar | uppercase">
                    <div class="invalid-feedback" *ngIf="submitted && u.controls.aadhaar.errors">
                      <span *ngIf="u.controls.aadhaar.errors.required || u.controls.aadhaar.errors.pattern">Please
                        provide a valid
                        Aadhar Number.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="pan" class="form-label">PAN</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-barcode-reader'></i></span>
                    <input type="text" class="form-control ps-1" id="pan" placeholder="Enter PAN number" readonly
                      [ngClass]="{'is-invalid': submitted && e.pan?.errors}" formControlName="pan" autocomplete="off"
                      [attr.value]="profileForm.value.pan | uppercase" />
                    <div class="invalid-feedback" *ngIf="submitted && e.pan && e.pan.errors">
                      <span *ngIf="e.pan.errors.required">Please provide a PAN number.</span>
                      <span *ngIf="e.pan.errors.pattern">Please provide a valid PAN number.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="Logo" class="form-label">Avatar</label>
                  <div class="input-group">
                    <input type="file" class="custom-file-input form-control" id="upload" 
                      (change)="getAndSetBase64($event)" accept=".jpg,.jpeg,.png" formControlName="avatar">
                  </div>
                </div>
              </div>
              <hr>
              <h5 class="d-flex align-items-center mb-1">User Details</h5>
              <div class="row g-3" formGroupName="userData">
                <div class="col-md-4">
                  <label for="username" class="form-label">Username</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user-plus'></i></span>
                    <input type="text" class="form-control ps-1" formControlName="username" id="username" readonly
                      placeholder="Enter your email"
                      [ngClass]="{'is-invalid': submitted && a.controls.username?.errors}" autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.controls.username.errors">
                      <span *ngIf="a.controls.username.errors.required">Please provide a valid username.</span>
                      <span *ngIf="a.controls.username.errors.pattern">Please provide a valid username.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="role" class="form-label">Role</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="roleId" disabled
                      placeholder="Select Role" [ngClass]="{'is-invalid': submitted && a.controls.roleId?.errors}"
                      [readonly]="a.controls.id.value">
                      <ng-option *ngFor="let role of roles;" [value]="role.id">{{role.name}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && a.controls.roleId.errors">
                      <span *ngIf="a.controls.roleId.errors.required">Please select a role.</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-auto ms-auto">
                  <button type="submit" class="btn btn-secondary rcx-btn" #inProgress>
                    <ng-container *ngIf="inProgress?.value === 'true'; else updateLabel">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                      </span>
                      Updating...
                    </ng-container>
                    <ng-template #updateLabel> <i class="bx bx-save"></i>
                      Update
                    </ng-template>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>